"use client";

import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

export default function OffersSlider({
  offersData = [],
  backgroundColor,
  onExplore,
  onBookNow,
}) {
  const [showNavigation, setShowNavigation] = useState(false);

  const stripHtml = (html) => {
    if (!html) return "";
    return html.replace(/<[^>]*>?/gm, "");
  };

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < 768;

      // Mobile → show nav only if more than 1 slide
      // Desktop → show nav only if more than 3 slides
      if (isMobile) {
        setShowNavigation(offersData.length > 1);
      } else {
        setShowNavigation(offersData.length > 3);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [offersData]);

  return (
    <section className="container">
      {/* Heading */}
      <section className="text-center py-12 px-4">
        <h1
          className="text-orange custom-hotel-header fw-semibold mb-3"
          style={{ color: backgroundColor }}
        >
          OUR OFFERS
        </h1>

        <div
          className="w-10 h-1 bg-orange-500 mx-auto mt-2 mb-4"
          style={{ background: backgroundColor }}
        ></div>

        <p className="max-w-3xl custom-hotel-description mx-auto text-gray-600">
          Check out our exclusive offers and discounts designed specifically to
          ensure that your trip is not just a great experience but also
          pocket-friendly and good value for money.
        </p>
      </section>

      {/* Swiper */}
      <div className="offersSection">
        <Swiper
          modules={[Navigation]}
          navigation={showNavigation}
          spaceBetween={24}
          slidesPerView={2}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1200: { slidesPerView: 2.5 },
          }}
        >
          {offersData?.map((offer, index) => (
            <SwiperSlide key={index}>
              <div className="card h-100 rounded-4 shadow-sm">
                <div className="card-body d-flex flex-column justify-content-center p-4">
                  <h5 className="card-title fw-semibold mb-2 !text-[16px]">
                    {offer?.offerTitle}
                  </h5>

                  <p className="card-text text-muted mb-4 text-[15px]">
                    {(() => {
                      const text =
                        offer?.offerDesc && offer.offerDesc.length > 0
                          ? offer.offerDesc
                          : offer?.offerTitle || "";

                      return text.length > 50
                        ? `${stripHtml(text.slice(0, 45))}...`
                        : stripHtml(text);
                    })()}
                  </p>

                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-outline-secondary rounded-0 !text-[11px]"
                      onClick={() => onExplore(offer)}
                    >
                      Explore
                    </button>

                    <button
                      className="btn text-white rounded-0 !text-[10px]"
                      style={{ backgroundColor: backgroundColor }}
                      onClick={() =>{onBookNow(offer)}}
                    >
                      Book Now
                    </button>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}